<template>
  <div class="content-wrapper">
    <vx-card>
		<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner ">
			<vs-tab label="Seller Info">
				<InfoForm
					:form="form"
					:e="e"
                    @submitBasic="submitBasic"
                    :role="role"
				></InfoForm>
			</vs-tab>
			<vs-tab label="Theme">
				<ThemeForm
					:form="form"
					:e="e"
                    :folder="folder"
                    :role="role"
                    @submitBasic="submitBasic"
				></ThemeForm>
			</vs-tab>
			<vs-tab label="Payments">
				<PaymentForm
					:form="form"
					:e="e"
                    :role="role"
                    @submitBasic="submitBasic"
				></PaymentForm>
			</vs-tab>
			<vs-tab label="Tracking">
				<TrackingForm
					:form="form"
					:e="e"
                    @submitBasic="submitBasic"
				></TrackingForm>
			</vs-tab>
			<vs-tab label="Documents">
				<DocumentForm
					:form="form"
					:e="e"
                    @submitBasic="submitBasic"
				></DocumentForm>
			</vs-tab>
			<vs-tab label="Defaults">
				<DefaultForm
					:form="form"
					:e="e"
                    @submitBasic="submitBasic"
				></DefaultForm>
			</vs-tab>
			<vs-tab label="Contact">
				<ContactForm
					:form="form"
					:e="e"
                    @submitBasic="submitBasic"
				></ContactForm>
			</vs-tab>
            <vs-tab label="Fee">
				<div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Fee</span>
                        <div style="font-size:0.75rem; color:#aaa;"></div>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input
                            class="w-full"
                            v-model="form.fee"
                            onkeypress="return /^[0-9]/i.test(event.key)"
                        />
                    </div>
                </div>
                <div style="height:10px;"></div>
                <div class="vx-row pt-5 mt-5">
                    <div class="vx-col w-full ml-auto">
                        <vs-button class="mr-3 mb-2" @click="submitBasic(form)">Submit</vs-button>
                        <vs-button class="mr-3 mb-2" type="border" @click="canceled">Cancel </vs-button>
                    </div>
                </div>
			</vs-tab>
			<vs-tab label="Advanced">
				<AdvancedForm
					:form="form"
					:e="e"
                    :role="role"
                    @submitBasic="submitBasic"
				></AdvancedForm>
			</vs-tab>
		</vs-tabs>
    </vx-card>
  </div>
</template>
<script>
import { Validator } from "vee-validate";
import { mapState } from "vuex";

import Service from "@/services";

import InfoForm from "@/components/soldoutt/merchant/InfoForm";
import ContactForm from "@/components/soldoutt/merchant/ContactForm";
import ThemeForm from "@/components/soldoutt/merchant/ThemeForm";
import PaymentForm from "@/components/soldoutt/merchant/PaymentForm";
import TrackingForm from "@/components/soldoutt/merchant/TrackingForm";
import DocumentForm from "@/components/soldoutt/merchant/DocumentForm";
import DefaultForm from "@/components/soldoutt/merchant/DefaultForm";
import AdvancedForm from "@/components/soldoutt/merchant/AdvancedForm";

export default {
    components: {
        InfoForm,
        ContactForm,
        ThemeForm,
        PaymentForm,
        TrackingForm,
        DocumentForm,
        DefaultForm,
        AdvancedForm
    },
    data: () => ({
        activeTab: 0,
        form: {
            address: '',
            alert_email: '',
            alert_phone: '',
            attendee_per_event: '',
            awcid: '',
            awclabel: '',
            bank1: null,
            bank2: null,
            bankaccname1: '',
            bankaccname2: '',
            bankaccno1: '',
            bankaccno2: '',
            bgcolor: '',
            branch: '',
            code_footer: '',
            coname: '',
            contactperson: '',
            defaultcourier: '',
            domain_ec: '',
            email: '',
            emailfromemail: '',
            emailfromname: '',
            event_per_month: '',
            fbpage: '',
            fbpid: '',
            fee: '',
            folder: '',
            font: '',
            gaid: '',
            gtmid: '',
            hicolor: '',
            instruction: '',
            intro: '',
            lineaddurl: '',
            lineid: '',
            phone: '',
            shipaddress: '',
            shorturl: '',
            smspass: '',
            smssender: '',
            smsuser: '',
            supportno: '',
            taxid: '',
            txtcolor: '',
            wht_vat: '',
            pay_creditcard: 1,
            pay_transfer: 1,
            disinttrack: 0,
        },
        folder: null,
        role: 'user'
    }),
    computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
    created() {
        setTimeout(() => {
            this.getRole();
            this.fethData();
        }, 1000);
    },
    methods: {
        getRole() {
            const folder = this.e
            Service.Event.get(folder)
                .then(res => {
                    this.role = res.data.role
                })
                .catch(() => {})
        },
        fethData() {
        let data = {
            e: this.e,
            s: this.s,
            perPage: 100,
            id: this.$route.params.merchant_id
        };


        let params = Object.keys(data)
            .map(key => key + "=" + data[key])
            .join("&");

            Service.Merchant.getMerchantDetail(data.id, data.s)
                .then(res => {
                    this.form = res.data;
                    this.getInfo(this.form)
                    // this.form.wht_status = res.data.wht_status ? res.data.wht_status : 1;
                    this.form.wht_status = res.data.wht_status;
                    this.form.pay_creditcard = res.data.pay_creditcard === null ? 1: res.data.pay_creditcard;
                    this.form.pay_transfer = res.data.pay_transfer === null? 1: res.data.pay_transfer;
                    // this.form.disinttrack = res.data.disinttrack ? res.data.disinttrack : 0;
                    this.form.disinttrack = res.data.disinttrack;

                    this.form.domain = res.data.domain != 'null' ? res.data.domain: '';
                    this.form.emailfromname = res.data.emailfromname != 'null' ? res.data.emailfromname: '';
                    this.form.emailfromemail = res.data.emailfromemail != 'null' ? res.data.emailfromemail: '';
                    this.form.smssender = res.data.smssender != 'null' ? res.data.smssender: '';
                    this.form.smsuser = res.data.smsuser != 'null' ? res.data.smsuser: '';
                    this.form.smspass = res.data.smspass != 'null' ? res.data.smspass: '';
                    this.form.fbpage = res.data.fbpage != 'null' ? res.data.fbpage: '';
                    this.form.lineid = res.data.lineid != 'null' ? res.data.lineid: '';
                    this.form.domain_ec = res.data.domain_ec != 'null' ? res.data.domain_ec: '';
                    this.form.defaultcourier = res.data.defaultcourier != 'null' ? res.data.defaultcourier: '';


                    this.form.defaultlang = ( res.data.defaultlang != undefined || res.data.defaultlang != null) ? res.data.defaultlang : 'en'

                    this.form.bank1 = res.data.bank1 != 'null' ? res.data.bank1: '';
                    this.form.bankaccname1 = res.data.bankaccname1 != 'null' ? res.data.bankaccname1: '';
                    this.form.bankaccno1 = res.data.bankaccno1 != 'null' ? res.data.bankaccno1: '';
                    this.form.bank2 = res.data.bank2 != 'null' ? res.data.bank2: '';
                    this.form.bankaccname2 = res.data.bankaccname2 != 'null' ? res.data.bankaccname2: '';
                    this.form.bankaccno2 = res.data.bankaccno2 != 'null' ? res.data.bankaccno2: '';

                    this.form.wht_vat = res.data.wht_vat != 'null' ? res.data.wht_vat: '';

                    this.form.gtmid = res.data.gtmid != 'null' ? res.data.gtmid: '';
                    this.form.gaid = res.data.gaid != 'null' ? res.data.gaid: '';
                    this.form.fbpid = res.data.fbpid != 'null' ? res.data.fbpid: '';
                    this.form.awcid = res.data.awcid != 'null' ? res.data.awcid: '';
                    this.form.awclabel = res.data.awclabel != 'null' ? res.data.awclabel: '';
                    this.form.code_footer = res.data.code_footer != 'null' ? res.data.code_footer: '';

                    this.form.coname = res.data.coname != 'null' ? res.data.coname: '';
                    this.form.address = res.data.address != 'null' ? res.data.address: '';
                    this.form.taxid = res.data.taxid != 'null' ? res.data.taxid: '';
                    this.form.branch = res.data.branch != 'null' ? res.data.branch: '';

                    this.form.intro = res.data.intro != 'null' ? res.data.intro: '';
                    this.form.instruction = res.data.instruction != 'null' ? res.data.instruction: '';

                    this.form.phone = res.data.phone != 'null' ? res.data.phone: '';
                    this.form.email = res.data.email != 'null' ? res.data.email: '';
                    this.form.contactperson = res.data.contactperson != 'null' ? res.data.contactperson: '';
                    this.form.shipaddress = res.data.shipaddress != 'null' ? res.data.shipaddress: '';

                    this.form.alert_phone = res.data.alert_phone != 'null' ? res.data.alert_phone: '';
                    this.form.alert_email = res.data.alert_email != 'null' ? res.data.alert_email: '';
                })
                .catch(() => {
                    /* this.$router.push("/pages/error-404").catch(() => {}); */
                });
        },
        getInfo(val) {
            this.form.supportno = val.supportno === 'null' ? '': val.supportno;
        },
        submitBasic(val) {
            // this.$vs.loading();
            const merchant = {
                id: this.$route.params.merchant_id,
            };
            this.form.s = this.s
            // this.form = {
            //     ...this.form,
            //     s: this.s
            // }
            const formData = new FormData();
            const dataKeyForms = Object.keys(val);
            for (let index = 0; index < dataKeyForms.length; index++) {
                const key = dataKeyForms[index];
                const value = val[key] === null ? '': val[key];

                formData.append(key,value);
            }

            Service.Merchant.updateMerchant(formData, merchant.id)
                .then(res => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        title: "Success",
                        text: "Update complete.",
                        color: "success"
                    });
                    this.$router.push('/sellers?s=' + this.s + '&e=' + this.e)
                })
                .catch(e => {
                    this.$vs.loading.close();
                });
        },
        canceled() {
            this.$router.push('/sellers')
        },
    }
};
</script>
